import { ScenarioSizing } from '@/dto/scenario/sizing/ScenarioSizing';
import { DtoExt } from '@/classes/scenario/DtoExt';
// import { BatteryTypeRef } from '@/dto/scenario/battery/BatteryReference';

export class ScenarioDevExt extends DtoExt {

  public static fromDto(dto: ScenarioSizing): ScenarioDevExt {
    return new ScenarioDevExt({
    } as any);
  }

  // public pvCapacity: number | null = null;
  // public batteryCapacityNotRequired: number | null = null;
  // public batteryCapacityWithDefault: number | null = null;
  // public batteryCapacityWithLock: number | null = null;

  // public hasGrid: boolean | null = null;
  // public hasGridNotRequired: boolean | null = null;
  // public hasGridWithDefault: boolean | null = null;
  // public hasGridWithLock: boolean | null = null;

  // public name: string | null = null;
  // public nameNotRequired: string | null = null;
  // public nameWithDefault: string | null = null;
  // public nameWithLock: string | null = null;

  // public typeRef: BatteryTypeRef | null = null;
  // public typeRefNotRequired: BatteryTypeRef | null = null;
  // public typeRefWithDefault: BatteryTypeRef | null = null;
  // public typeRefWithLock: BatteryTypeRef | null = null;

  // public dayConsumptionPercentage: number | null = null;
  // public dayConsumptionPercentageNotRequired: number | null = null;
  // public dayConsumptionPercentageWithDefault: number | null = null;
  // public dayConsumptionPercentageWithLock: number | null = null;

  // public startDate: Date | null = null;
  // public startDateNotRequired: Date | null = null;
  // public startDateWithDefault: Date | null = null;
  // public startDateWithLock: Date | null = null;

  constructor(options?: ScenarioDevExt | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }
}
